var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { Layout } from 'antd';
import { AppBar } from '../AppBar';
var Header = Layout.Header, Content = Layout.Content;
export var AppLayout = React.memo(function AppLayoutImpl(props) {
    return (_jsx(_Fragment, { children: _jsxs(Layout, __assign({ id: 'main-layout' }, { children: [_jsx("span", { id: 'main-bg' }), _jsx("span", { id: 'bg-gradient' }), _jsx("span", { id: 'static-header-gradient' }), _jsx("span", { id: 'static-end-gradient' }), _jsxs(Layout, __assign({ id: 'width-layout' }, { children: [_jsx(Content, __assign({ style: {
                                padding: '30px 48px ',
                                flex: 'unset',
                            } }, { children: _jsx(Header, __assign({ className: "App-Bar" }, { children: _jsx(AppBar, {}) })) })), _jsx(Content, __assign({ style: {
                                overflow: 'scroll',
                                paddingLeft: '96px',
                                paddingRight: '96px',
                                paddingBottom: '30px',
                                paddingTop: '-30px',
                            } }, { children: props.children }))] }))] })) }));
});
